import { render, staticRenderFns } from "./TipologiaFormDialog.vue?vue&type=template&id=156cf8a2&scoped=true&"
import script from "./TipologiaFormDialog.vue?vue&type=script&lang=js&"
export * from "./TipologiaFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./TipologiaFormDialog.vue?vue&type=style&index=0&id=156cf8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156cf8a2",
  null
  
)

export default component.exports